import { useNavigate, useParams } from "react-router-dom";
import { useEventDetails } from "../../api/event/queryHooks";
import Topbanner from "../../components/topbanner";
import { decodeId } from "../../api/utils";
import { GoHome } from "react-icons/go";
import ROUTES from "../../router/routes";

const Header = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading } = useEventDetails(id);
  const navigate = useNavigate();

  return (
    <>
      <Topbanner />
      <div className="p-5 bg-[#111111] shadow-xl">
        <div className="flex items-center gap-[14px]">
          <span className="cursor-pointer" onClick={() => navigate(ROUTES.INDEX)}>
            <GoHome className="text-2xl" />
          </span>
          {isLoading ? (
            <span className="text-lg min-w-[200px] h-7 skeleton"></span>
          ) : (
            <span className="text-lg">{data?.data?.name}</span>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
